module.exports = __webpack_public_path__ + "img/2200-2_YR_2022_Spyware.1e6f81e2.png";